import {Routes} from '@angular/router';
import {RoutingConstants} from './models/routing/routing-constants';
import {LoginComponent} from './views/login/login.component';
import {Routing} from './models/routing/routing';
import {AclPolicy, AuthenticatedAndActivatedPolicy, AuthenticatedPolicy} from './guards/authentication.guard';
import {environment} from '../environments/environment';
import {AppLayoutComponent} from './layout/app.layout.component';
import {translations} from './app.translations';
import {DashboardComponent} from './views/intranet/dashboard.component';
import {ResetPasswordComponent} from './views/request-recovery-password/reset-password/reset-password.component';
import {RequestRecoveryPasswordComponent} from './views/request-recovery-password/request-recovery-password.component';
import {UsersListComponent} from './views/intranet/users/users-list/users-list.component';
import {UserFormComponent} from './views/intranet/users/user-form/user-form.component';
import {AclGroupsListComponent} from './views/intranet/acl/acl-groups-list/acl-groups-list.component';
import {AclPermission} from './models/acl/acl-group';
import {MovieFormComponent} from './views/intranet/movie-form/movie-form.component';
import {GenresListComponent} from './views/intranet/genres/genres-list/genres-list.component';
import {SliderManagerComponent} from './views/intranet/slider-manager/slider-manager.component';
import {CatalogueImportComponent} from './views/intranet/catalogue-import/catalogue-import.component';
import {RecapCatalogueImportComponent} from './views/intranet/recap-catalogue-import/recap-catalogue-import.component';

const {params} = RoutingConstants;

export const routes: Routes = [
  {path: RoutingConstants.login, component: LoginComponent},
  {path: RoutingConstants.mustActivate, component: LoginComponent, data: {mustActivate: true}},
  // {path: RoutingConstants.register, component: environment.allowRegistration ? RegisterComponent : LoginComponent},
  // {path: RoutingConstants.registered, component: RegisteredComponent},
  {path: Routing.recoveryPassword.resetPassword(params.id), component: ResetPasswordComponent, pathMatch: 'full'},
  {path: Routing.recoveryPassword.getBasePath(), component: RequestRecoveryPasswordComponent},
  {path: '', redirectTo: Routing.dashboard.getBasePath(), pathMatch: 'full'},

  {
    path: '', component: AppLayoutComponent, canActivate: [AuthenticatedAndActivatedPolicy],
    children: [
      {
        path: Routing.dashboard.getBasePath(),
        component: DashboardComponent,
        data: {breadcrumb: 'dashboard'},
      },
      {
        path: Routing.movies.catalogueImport(),
        component: CatalogueImportComponent,
        data: {breadcrumb: 'import-catalogue'},
      },
      {
        path: Routing.movies.catalogueImportRecap(params.id),
        component: RecapCatalogueImportComponent,
        data: {breadcrumb: 'recap-import-catalogue'},
      },
      {
        path: Routing.movies.edit(params.id),
        component: MovieFormComponent,
        data: {breadcrumb: 'movie'},
      },
      {
        path: Routing.users.getBasePath(),
        component: UsersListComponent,
        data: {breadcrumb: 'users'},
      },
      {
        path: Routing.genres.getBasePath(),
        component: GenresListComponent,
        data: {breadcrumb: 'genres'},
      },
      {
        path: Routing.carousel.getBasePath(),
        component: SliderManagerComponent,
        data: {breadcrumb: 'carousel'},
      },
      {
        path: Routing.users.byId(params.id),
        canActivate: [AclPolicy],
        component: UserFormComponent,
        data: {
          breadcrumb: 'user',
          acl: [AclPermission.AdminUsers]
        },
      },
      {
        path: Routing.acl.getBasePath(),
        canActivate: [AclPolicy],
        component: AclGroupsListComponent,
        data: {
          breadcrumb: 'acl',
          acl: [AclPermission.AclManagement]
        },
      },
    ]
  },
  {path: '**', redirectTo: Routing.dashboard.getBasePath()}
];
